/* eslint-disable */

// This file was copied from https://github.com/minervaproject/rich-text on September 4, 2025.
// It was originally a heavily modified fork of https://github.com/ot-types/ot-rich-text.
// Original file and comments from original author below:
// --------------------

import Delta from "quill-delta";

// Slightly modified from the base rich-text implementation
function transformCursor(cursor, delta, isOwnOp) {
  // Rewrap in Quill Delta since we seem to get a raw ops object
  delta = new Delta(delta);
  return delta.transformPosition(cursor, !isOwnOp);
}

// Copied from https://github.com/Teamwork/ot-rich-text/blob/master/src/Operation.js
function createPresence(presence) {
  return isValidPresence(presence)
    ? presence
    : {
        cursor: {
          u: "",
          c: 0,
          s: [],
        },
      };
}

// Copied from https://github.com/Teamwork/ot-rich-text/blob/master/src/Operation.js
function transformPresence(presence, operation, isOwnOperation) {
  if (!presence.s) {
    return presence;
  }
  const selections = presence.s;
  const newSelections = new Array(selections.length);

  for (let i = 0, l = selections.length; i < l; ++i) {
    const selection = selections[i];
    const newStart = transformCursor(selection[0], operation[0].o, isOwnOperation);
    const newEnd =
      selection[0] === selection[1]
        ? newStart
        : transformCursor(selection[1], operation[0].o, isOwnOperation);
    newSelections[i] = [newStart, newEnd];
  }

  return {
    ...presence,
    s: newSelections,
  };
}

// Copied from https://github.com/Teamwork/ot-rich-text/blob/master/src/Operation.js
function comparePresence(presence1, presence2) {
  if (presence1 === presence2) {
    return true;
  }

  if (
    presence1 == null ||
    presence2 == null ||
    presence1.cursor === null ||
    presence2.cursor === null ||
    presence1.cursor.u !== presence2.cursor.u ||
    presence1.cursor.c !== presence2.cursor.c ||
    presence1.cursor.s.length !== presence2.cursor.s.length
  ) {
    return false;
  }

  for (let i = 0, l = presence1.cursor.s.length; i < l; ++i) {
    if (
      presence1.cursor.s[i][0] !== presence2.cursor.s[i][0] ||
      presence1.cursor.s[i][1] !== presence2.cursor.s[i][1]
    ) {
      return false;
    }
  }

  return true;
}

// Copied from https://github.com/Teamwork/ot-rich-text/blob/master/src/Operation.js
function isValidPresence(presence) {
  if (
    presence == null ||
    typeof presence.u !== "string" ||
    typeof presence.c !== "number" ||
    !isFinite(presence.c) ||
    Math.floor(presence.c) !== presence.c ||
    !Array.isArray(presence.s)
  ) {
    return false;
  }

  const selections = presence.s;

  for (let i = 0, l = selections.length; i < l; ++i) {
    const selection = selections[i];

    if (
      !Array.isArray(selection) ||
      selection.length !== 2 ||
      selection[0] !== (selection[0] | 0) ||
      selection[1] !== (selection[1] | 0)
    ) {
      return false;
    }
  }

  return true;
}

export default {
  Delta,
  type: {
    name: "rich-text",
    uri: "http://sharejs.org/types/rich-text/v1",

    create(initial) {
      return new Delta(initial);
    },

    apply(snapshot, delta) {
      snapshot = new Delta(snapshot);
      delta = new Delta(delta);
      return snapshot.compose(delta);
    },

    compose(delta1, delta2) {
      delta1 = new Delta(delta1);
      delta2 = new Delta(delta2);
      return delta1.compose(delta2);
    },

    diff(delta1, delta2) {
      delta1 = new Delta(delta1);
      delta2 = new Delta(delta2);
      return delta1.diff(delta2);
    },

    transform(delta1, delta2, side) {
      delta1 = new Delta(delta1);
      delta2 = new Delta(delta2);
      // Fuzzer specs is in opposite order of delta interface
      return delta2.transform(delta1, side === "left");
    },

    transformCursor,

    normalize(delta) {
      return delta; // quill-delta is already canonical
    },

    serialize(delta) {
      return delta.ops;
    },

    deserialize(ops) {
      return new Delta(ops);
    },

    createPresence,
    transformPresence,
    comparePresence,
    isValidPresence,
  },
};
